export const isUncategorized = (category = {}) => {
  const slug = String(category.category_slug || "").toLowerCase();
  if (slug === "uncategorized") return true;
  return Number(category.is_uncategorized) === 1;
};

export const filterVisibleCategories = (list = []) =>
  list.filter((category) => !isUncategorized(category));

